@if (true) {
  <app-collapse [rounded]="true" [collapse]="collapseMovement"
                [showOnLoad]="!context.hasBeenDeclared() || (context.visit.orderNauticalServices && berthVisit.ata && !berthVisit.atd && !berthVisit.nextMovement.order)"
                [animateOnLoad]="true"
                [validationModel]="berthVisit.nextMovement" [renderWhenCollapsed]="true">
    <!-- Movement summary (icons: pilot / tugboats / boatment / draft etc. ) -->
    <div class="d-flex p-2">
      <!-- Order status icon (plane / check / cross / etc.)-->
      <span class="me-3">
        <app-order-status [orderStatus]="getOrderStatus()"></app-order-status>
        @if (context.visit.orderNauticalServices) {
          @if (context.visit.berthVisitInfos[berthVisit.id]; as berthVisitInfo) {
            @if (berthVisitInfo?.harbourMasterInfo?.remarks) {
              <span
                title="{{berthVisitInfo.harbourMasterInfo.remarks.text}}"
                class="ms-1 fa fa-fw fa-comment-alt text-warning"></span>
            }
            @if (berthVisitInfo?.harbourMasterInfo?.rejectionReason) {
              <span
                title="{{berthVisitInfo.harbourMasterInfo.rejectionReason}}"
                class="ms-1 fa fa-fw fa-comment-alt text-warning"></span>
            }
            @if (berthVisitInfo?.harbourMasterInfo?.movementOnHold) {
              <span
                title="Your departure from berth {{berthVisit.berth.code}} has been put on hold by the port
                  authorities and may proceed as conditions allow."
                class="ms-1 far fa-fw fa-hand-paper text-danger"></span>
            }
          }
        }
      </span>
      <div class="d-flex align-items-center">
        <app-movement-summary [berthVisit]="berthVisit" [nextBerthVisit]="getNextBerthVisit"
                              [berthVisitInfo]="getBerthVisitInfo()"></app-movement-summary>
      </div>
      <app-movement-clearance-status
        [clearanceKey]="$any('ekh')"
        [arrivalBerthVisitId]="arrivalBerthVisitId"
        [departureBerthVisitId]="departureBerthVisitId">
      </app-movement-clearance-status>
    </div>
  </app-collapse>
  <ng-template #collapseMovement>
    <div class="collapse">
      <div class="border rounded-bottom p-3 mb-3">
        <!-- CURRENT DECLARANT -->
        @if (!(isBerthOfTransfer && context.isOrganisationNextDeclarant())) {
          <div class="fieldset" [ngClass]="{'disabled' : !isNextBerthVisits && nextBerthVisitHasAta()}">
            <app-movement [ngModel]="berthVisit.nextMovement" [id]="berthVisit.id + '-nextMovement'">
            </app-movement>
          </div>
        }
        <!-- NEXT DECLARANT -->
        @if (isBerthOfTransfer && context.isOrganisationNextDeclarant()) {
          <div class="always-enabled validate-for-next-declarant"
          >
            @if (context.visit.nextVisitDeclaration?.lastBerthVisitDeparture) {
              <app-movement [ngModel]="context.visit.nextVisitDeclaration.lastBerthVisitDeparture.nextMovement"
                            [id]="berthVisit.id + '-nextMovement'"></app-movement>
            }
          </div>
        }
        <!-- NAUTICAL SERVICES -->
        @if (areNauticalServicesApplicable(context.visit.portOfCall.port.locationUnCode)) {
          <div class="row">
            <div class="declaration-block col-md-12">
              <app-nautical-services [berthVisit]="berthVisit" [firstBerth]="firstBerth" [lastBerth]="lastBerth"
                                     [nextBerthVisit]="getNextBerthVisit" [disabled]="!!berthVisit.atd"
                                     [isNextBerthVisits]="isNextBerthVisits"
                                     [isLastBerthVisitDeparture]="isBerthOfTransfer && context.isOrganisationNextDeclarant()">
              </app-nautical-services>
            </div>
          </div>
        }
      </div>
    </div>
  </ng-template>
}
